import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';
import device from "utils/device";

const HeaderWrapper = styled.div`
  ${({ theme }) => css`
    min-height: 60px;

    display: flex;
    justify-content: space-between;
    align-items: center
    background-color: ${`${theme?.colour?.primary}0D`};

    @media ${device.tablet} {
      height: 100px;
    }
  `}
`;

export default Wrapper(HeaderWrapper)
